import React, { Suspense } from "react";
import { Spinner } from "@fluentui/react";

const routeFallbackStyles: React.CSSProperties = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  minHeight: "100vh",
};

export function lazyWithSuspense<T extends React.ComponentType<any>>(
  factory: () => Promise<{ default: T }>,
) {
  const Page = React.lazy(factory);
  const Wrapped = (props: React.ComponentProps<T>) => (
    <Suspense
      fallback={
        <div style={routeFallbackStyles}>
          <Spinner />
        </div>
      }
    >
      <Page {...props} />
    </Suspense>
  );

  return Wrapped;
}
